<template>
  <div id="quiz-list">
    <b-card no-body class="p-2 container-card">
      <b-row>
        <b-col cols="12">
          <div class="d-flex justify-content-end mb-1">
            <add-button 
            v-if="getPermissionModule('Survey and Quiz').adjust"
            :btn-label="'Quiz'" 
            @click.native="onCreateQuiz" 
            />
          </div>
          <div class="d-flex justify-content-end">
            <div class="search-container mb-1">
              <search :on-search-input="onSetValueSearch" />
            </div>
          </div>
        </b-col>
        <b-col cols="12" class="mb-1">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <!-- <b-table
                :fields="fields"
                :items="quizListTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                class="default-static-table text-center"
              > -->
              <b-table
                :fields="fields"
                :items="quizListTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                class="default-static-table-vertical text-center"
              >
                <template #cell(cover_image_url)="data">
                  <img
                    :src="data.item.quiz.cover_image_url || DefaultImg"
                    class="image-column"
                  />
                </template>
                <template #cell(title_name)="data">
                  <span>{{ data.item.quiz.title_name }}</span>
                </template>
                <template #cell(valid_from)="data">
                  <span>{{
                    resolveDateWithSeperator(data.item.quiz.valid_from)
                  }}</span>
                </template>
                <template #cell(valid_through)="data">
                  <span>{{
                    resolveDateWithSeperator(data.item.quiz.valid_through)
                  }}</span>
                </template>
                <template #cell(updatedtime)="data">
                  <span>{{
                    resolveDateWithSeperator(data.item.quiz.updatedtime)
                  }}</span>
                </template>
                <template #cell(status)="data">
                  <!-- <pre>{{data.item.quiz}}</pre> -->
                  <b-form-checkbox
                    field-value="true"
                    class="custom-control-success custom-toggle w-50px"
                    name="check-button"
                    switch
                    :checked="data.item.quiz.status == 1 ? true : false"
                    @change="onToggleStatus($event, data.item.quiz)"
                  >
                    <span class="switch-icon-left toggle-text">{{ "" }}</span>
                    <span class="switch-icon-right toggle-text">{{ "" }}</span>
                  </b-form-checkbox>
                </template>
                <template #cell(actions)="data">
                  <div
                    v-if="getPermissionModule('Survey and Quiz').adjust"
                    class="d-flex align-item-center justify-content-end mr-4"
                  >
                    <div
                      v-if="data.item.have_dashboard"
                      class="mr-4 dashboard-wrp"
                      @click="onOpenDashboard(data.item)"
                    >
                      <icon-dashboard
                        class="svg-icon"
                        v-b-tooltip.hover
                        title="Dashboard"
                      />
                    </div>
                    <edit-icon
                      class="svg-icon mr-4 iconEdit-btn"
                      v-b-tooltip.hover
                      title="Edit"
                      @click.native="
                        $router.push(
                          '/quiz/info/' + data.item.quiz.quiz_groupid
                        )
                      "
                    />
                    <delete-icon
                      class="svg-icon"
                      v-b-tooltip.hover
                      title="Delete"
                      @click.native="onRemoveQuiz(data.item.quiz)"
                    />
                  </div>
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12">
          <pagination-with-reorder
            entity-editable
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import DefaultImg from "@/assets/images/icons/no-img-square.jpg";
import AddButton from "@/views/components/button/AddButton.vue";
import Search from "@/views/components/search/Search.vue";
import OverlayLoading from "@/views/components/loading/OverlayLoading.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import EditIcon from "@/@core/components/svg/common/Edit.vue";
import DeleteIcon from "@/@core/components/svg/common/Trash.vue";
import useQuizList from "@/views/pages/survey-quiz/quiz-list/hooks/useQuizList";
import IconDashboard from "@/@core/components/svg/common/IconDashboard.vue";
import { onBeforeMount } from "@vue/composition-api";

export default {
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    CardNoItem,
    DefaultImg,
    AddButton,
    Search,
    EditIcon,
    DeleteIcon,
    OverlayLoading,
    PaginationWithReorder,
    IconDashboard,
  },
  setup() {
    const {
      loading,
      optionData,
      fields,
      pagination,
      onPageChange,
      onFilterEntity,
      filters,
      ordering,
      onSetValueSearch,
      onSelectFilter,
      quizListTable,
      onCreateQuiz,
      onRemoveQuiz,
      resolveDateWithSeperator,
      resolveTime,
      onToggleStatus,
      onOpenDashboard,
      getPermissionModule
    } = useQuizList();

    return {
      loading,
      optionData,
      fields,
      pagination,
      onPageChange,
      onFilterEntity,
      filters,
      ordering,
      onSetValueSearch,
      onSelectFilter,
      quizListTable,
      onCreateQuiz,
      onRemoveQuiz,
      resolveDateWithSeperator,
      resolveTime,
      onToggleStatus,
      onOpenDashboard,
      getPermissionModule
    };
  },
};
</script>

<style>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";

#quiz-list .w-50px {
  width: 50px;
}

#quiz-list .dashboard-wrp {
  width: 35px;
  height: 35px;
  cursor: pointer;
}

#quiz-list .dashboard-wrp:hover {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #e5f2ff;
}

#quiz-list .default-static-table .dashboard-wrp:hover .svg-icon {
  transform: scale(1);
  fill: #2187ef !important;
}
</style>